import { useEffect, useMemo } from 'react';
import { NavLink, useLocation } from 'react-router';

import navBarCurve from '@perpay-web/fintech/assets/images/Subtract.svg';
import { useShopPath } from '@perpay-web/fintech/hooks/useShopPath';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './BottomNav.scss';

const BottomNav = ({
    cardButtonRoute,
    launchSupportToolHandler,
    analyticsBottomNavOnClickHome,
    analyticsBottomNavOnClickCard,
    analyticsBottomNavOnClickShop,
    analyticsBottomNavOnClickMarketplace,
    analyticsBottomNavOnClickSupport,
    onMount,
}) => {
    const { shopPath, lastShopPath } = useShopPath();
    const location = useLocation();

    const shopHref = useMemo(() => {
        if (location.pathname.startsWith('/shop')) {
            return shopPath;
        }
        return lastShopPath;
    }, [shopPath, lastShopPath, location.pathname]);

    useEffect(() => {
        onMount();
    }, [onMount]);

    return (
        <div className={styles.footer}>
            <NavLink
                className={({ isActive }) =>
                    getClassName(
                        styles.nav__block,
                        isActive ? styles['nav__block--active'] : null,
                    )
                }
                to={paths.dashboard.path}
                onClick={analyticsBottomNavOnClickHome}
            >
                <div
                    className={getClassName(
                        styles.nav__icon,
                        styles.nav__home__icon,
                    )}
                />
                <div className={styles.nav__label}>Home</div>
            </NavLink>

            <NavLink
                className={({ isActive }) =>
                    getClassName(
                        styles.nav__block,
                        isActive ? styles['nav__block--active'] : null,
                    )
                }
                to={cardButtonRoute}
                onClick={analyticsBottomNavOnClickCard}
            >
                <div
                    className={getClassName(
                        styles.nav__icon,
                        styles.nav__card__icon,
                    )}
                />
                <div className={styles.nav__label}>Card</div>
            </NavLink>

            <div className={styles.floating__btn__wrapper}>
                <img
                    alt='nav bar curve'
                    src={navBarCurve}
                    className={styles.nav__subtract}
                />

                <NavLink
                    className={({ isActive }) =>
                        getClassName(
                            styles.nav__block,
                            isActive ? styles['nav__block--active'] : null,
                            styles.nav__floating__button,
                        )
                    }
                    to={shopHref}
                    onClick={analyticsBottomNavOnClickShop}
                >
                    <div
                        className={getClassName(
                            styles.nav__icon,
                            styles.nav__shop__icon,
                        )}
                    />
                    <div
                        className={getClassName(
                            styles.nav__label,
                            styles.nav__shop__label,
                        )}
                    >
                        Shop
                    </div>
                </NavLink>
            </div>

            <NavLink
                className={({ isActive }) =>
                    getClassName(
                        styles.nav__block,
                        isActive ? styles['nav__block--active'] : null,
                    )
                }
                to={paths.marketplaceDetails.path}
                onClick={analyticsBottomNavOnClickMarketplace}
            >
                <div
                    className={getClassName(
                        styles.nav__icon,
                        styles.nav__marketplace__icon,
                    )}
                />
                <div className={styles.nav__label}>Marketplace</div>
            </NavLink>

            <button
                type='button'
                className={styles.nav__block}
                onClick={() => {
                    launchSupportToolHandler();
                    analyticsBottomNavOnClickSupport();
                }}
            >
                <div
                    className={getClassName(
                        styles.nav__icon,
                        styles.nav__support__icon,
                    )}
                />
                <div className={styles.nav__label}>Support</div>
            </button>
        </div>
    );
};

export default BottomNav;
